import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  StyleRulesCallback,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import Translator from '../../../components/Translator';
import { LanguageEntries } from '../../../shared/language/LanguageEntries';
import { clearSubmitErrors, FormAction } from 'redux-form';
import { connect } from 'react-redux';
import { disclosureFormName } from '../../../model/disclosureData';
import FintechOneContact from '../../../components/FintechOneSupport';

type CssClasses = 'errInfo';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  errInfo: {
    marginTop: '15px',
    marginBottom: '15px',
    fontSize: '13px',
  },
});

interface DispatchProps {
  clearError: (form: string) => FormAction;
}

interface OwnProps {
  error: string;
}

class DisclosureLoadErrorPage extends React.Component<OwnProps & DispatchProps & WithStyles<CssClasses>> {
  render() {
    let { classes, error } = this.props;

    let errorLanguageEntry: keyof LanguageEntries;

    switch (error) {
      case 'forbidden':
        errorLanguageEntry = 'forbiddenLoadError';
        break;
      case 'notfound':
        errorLanguageEntry = 'notFoundLoadError';
        break;
      default:
        errorLanguageEntry = 'unknownLoadError';
        break;
    }

    return (
      <Translator>
        {translate => {
          return (
            <Dialog open={true} onClose={this.closeErrorDialog}>
              <DialogTitle id="alert-dialog-title">{translate('submitErrorDialogTitle')}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ color: '#666' }}>
                  {translate('submitErrorDialogText')}
                </DialogContentText>
                <div className={classes.errInfo}>Error: {error}</div>
                <FintechOneContact withRequest={false} />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeErrorDialog} color="primary" autoFocus variant={'contained'}>
                  {translate('close')}
                </Button>
              </DialogActions>
            </Dialog>
          );
        }}
      </Translator>
    );
  }

  private closeErrorDialog = () => {
    this.props.clearError(disclosureFormName);
  };
}

const mapDispatchToProps: DispatchProps = {
  clearError: clearSubmitErrors,
};

export default pure(
  withStyles(styles)(
    connect(
      null,
      mapDispatchToProps
    )(DisclosureLoadErrorPage)
  )
);



// WEBPACK FOOTER //
// ./src/routes/disclosure/components/DisclosureErrorDialog.tsx